// GENERATED FILE, PLEASE DO NOT EDIT
export var None = 0;
export var Hairline = 1;
export var Default = 1;
export var Regular = 1;
export var Medium = 2;
export var Bold = 3;